/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminbypassconfirmtitle3Inputs */

const en_adminbypassconfirmtitle3 = /** @type {(inputs: Adminbypassconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass subscription limits?`)
};

const de_adminbypassconfirmtitle3 = /** @type {(inputs: Adminbypassconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement-Limits umgehen?`)
};

/**
* | output |
* | --- |
* | "Bypass subscription limits?" |
*
* @param {Adminbypassconfirmtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminbypassconfirmtitle3 = /** @type {((inputs?: Adminbypassconfirmtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminbypassconfirmtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminbypassconfirmtitle3(inputs)
	return de_adminbypassconfirmtitle3(inputs)
});
export { adminbypassconfirmtitle3 as "adminBypassConfirmTitle" }